/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscopylink2Inputs */

const en_partnerscopylink2 = /** @type {(inputs: Partnerscopylink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy partner link`)
};

const de_partnerscopylink2 = /** @type {(inputs: Partnerscopylink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partnerlink kopieren`)
};

/**
* | output |
* | --- |
* | "Copy partner link" |
*
* @param {Partnerscopylink2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscopylink2 = /** @type {((inputs?: Partnerscopylink2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscopylink2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscopylink2(inputs)
	return de_partnerscopylink2(inputs)
});
export { partnerscopylink2 as "partnersCopyLink" }